import Vue from 'vue'
import Vuex from 'vuex'
import client from './modules/client'
import auth from './modules/auth'
import configurations from './modules/configurations'
import pwpreview from './modules/pwpreview'
import VuexPersist from 'vuex-persist'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'configtool-app',
  storage: localStorage,
  reducer: state => ({
    configurations: state.configurations,
    client: state.client
  })
})

export default new Vuex.Store({
  modules: {
    auth,
    client,
    configurations,
    pwpreview
  },
  actions: {
    clearAll({
      commit,
      state
    }) {
      commit('client/reset')
      commit('configurations/reset')
    }
  },
  strict: debug,
  plugins: [vuexLocalStorage.plugin]
})
